import { snapshot } from 'valtio'
import { crudAtom } from '../crud'

export const getCrudSelection = (immutable: boolean = false) => {
  return immutable ? snapshot(crudAtom.selection) : crudAtom.selection
}
